// extracted by mini-css-extract-plugin
export default {"authHeader":"auth_page_authHeader__HZ3fs"};